export default "__VITE_ASSET__7fNBvFvB__"